import React, { useMemo } from 'react'
import Rings from './Rings'
import { abbreviateString } from '../../../common/utils/StringUtils'
import { chartjsTitleProperties } from '../../../common/Constants'
import I18n from 'i18n'

export const MAX_LEGEND_STRING_LENGTH = 100

export const legendLabelFilter = (item: any): boolean => {
  if ((item?.text ?? '').trim() === '') return false
  item.text = abbreviateString(item.text, MAX_LEGEND_STRING_LENGTH)
  return true
}

export const buildProgressRingConfig = (opts: {
  percent: number
}): any => {
  const value = opts.percent
  const remaining = 100 - value

  // So that when the values is 100 the ring is full.
  const data = value >= 100 ? [100] : [value, remaining]
  const colors = value >= 100 ? ['#011258'] : ['#011258', '#52B7E1']
  const labels = value >= 100 ? [''] : ['', '']

  return [{
    data: {
      datasets: [{
        data,
        backgroundColor: colors,
        borderWidth: 0
      }],
      labels
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
      events: [],
      animation: { animateRotate: false },
      cutout: '82%',
      plugins: {
        title: { ...chartjsTitleProperties },
        legend: {
          display: false
        },
        centerText: {
          text: `${Math.round(opts.percent)}%`,
          font: { size: 26, family: 'sans-serif', weight: 'bold' },
          color: '#011258'
        }
      }
    }
  }]
}

interface ResearchDashboardDataRingProps {
  label: string
  percent?: number | null
  emptyMessage?: string
}

const ResearchDashboardDataRing: React.FC<ResearchDashboardDataRingProps> = ({
  label,
  percent,
  emptyMessage = I18n.t('components.dashboards.research_dashboard.no_data_available')
}) => {
  const hasData = typeof percent === 'number' && !isNaN(percent)

  const ringConfigs = useMemo(() => {
    if (typeof percent !== 'number') return []
    return buildProgressRingConfig({ percent })
  }, [percent])

  return (
    <div className='watch-ring-wrapper'>
      {hasData
        ? (
          <>
            <div className='ring-label-text'>{label}</div>
            <Rings ringConfigs={ringConfigs} />
          </>
          )
        : (
          <div className='no-data-message' style={{ textAlign: 'left', padding: 20 }} aria-live='polite'>
            <p>{emptyMessage}</p>
          </div>
          )}
    </div>
  )
}

export default ResearchDashboardDataRing
